import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Datetime from 'react-datetime';
import { displayPhoneNumber, phoneNumberMaker, fetchApi } from '../../utils/methods';
import countryData from '../../../countryData.json';
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import {
  InputContainer,
  StyledInputV2,
  StyledLabel
} from '../CreateEvent/style';
import { FormContainer, FormRow, FormField, DateInputWrapper, CalendarIcon, StyledModalV2 } from './styles';
import { UpdateBirthdayPrivacy, CompanyLocationAPI, CompanyDepartmentAPI } from '../../redux/constants/apiConstants';
import CommonDropdown from '../common/CommonDropDown/CommonDropdown';
import { AdminCloseIcon, calendarNewIcon } from '../../utils/icons';

const privacyOptions = [
  { value: 'private', label: 'Private' },
  { value: 'public', label: 'Public' }
];

class ProfileEditForm extends Component {
  constructor(props) {
    super(props);
    const { user } = props;
    this.state = {
      firstName: user.fname || '',
      lastName: user.lname || '',
      department: user.department_id || '',
      phoneNumber: displayPhoneNumber(user.phone_number) || '',
      countryDropdown: user.country || '',
      companyLocation: user.city_state_id || '',
      birthday: user.birthday || '',
      birthdayPrivacy: user.visible_birthday ? 'public' : 'private',
      workAnniversary: user.work_anniversary_date || '',
      companyName: user.company_name || '',
      linkedinProfile: user.linkedin_profile || '',
      showDate: '',
      locationDropdownOpen: false,
      departmentDropdownOpen: false,
      countryDropdownOpen: false,
      privacyDropdownOpen: false,
      locationDetails: [],
      departmentDetails: [],
      showPrivacyModal: false,
      tempPrivacySelection: null
    };
  }

  componentDidMount() {
    const { onRef, user } = this.props;
    this.fetchLocation(user.company_id);
    this.fetchDepartment(user.company_id);
    if (onRef) {
      onRef(this);
    }
  }

  fetchLocation = async(companyId) => {
    try {
      const res = await fetchApi(`${CompanyLocationAPI}?company_id=${companyId}`, "GET");
      if (res?.data?.message) {
        toast.error(res.data.message);
      } else {
        this.setState({ locationDetails: res?.data || [] });
      }
    } catch (error) {
      toast.error('Error fetching locations');
    }
  };

  fetchDepartment = async(companyId) => {
    try {
      const res = await fetchApi(`${CompanyDepartmentAPI}?company_id=${companyId}`, "GET");
      if (res?.data?.message) {
        toast.error(res.data.message);
      } else {
        this.setState({ departmentDetails: res?.data || [] });
      }
    } catch (error) {
      toast.error('Error fetching departments');
    }
  };

  componentWillUnmount() {
    const { onRef } = this.props;
    if (onRef) {
      onRef(null);
    }
  }

  handleInputChange = (field, value) => {
    if (field === 'phoneNumber') {
      const reg = /^[0-9 -]+$/;
      if (value.length <= 12) {
        if (value === '' || reg.test(value)) {
          let phoneValue = '';
          if (this.state.phoneNumber.length < value.length) {
            phoneValue = (value.length === 3 || value.length === 7) ? value + '-' : value;
          } else {
            if (this.state.phoneNumber[this.state.phoneNumber.length - 1] === '-') {
              phoneValue = this.state.phoneNumber.slice(0, -1).slice(0, -1);
            } else {
              phoneValue = value;
            }
          }
          this.setState({ phoneNumber: phoneValue });
        }
      }
    } else if (field === 'firstName' || field === 'lastName') {
      if (value.length <= 30 && value !== ' ') {
        this.setState({ [field]: value.replace(/[&\\#,+()$~%@^!_.'":*?<>{}`|0-9]/g, "") });
      }
    } else {
      this.setState({ [field]: value });
    }
  };

  handleLocationSelect = (selectedItem) => {
    this.setState({ companyLocation: selectedItem.id, locationDropdownOpen: false });
  };

  handleDepartmentSelect = (selectedItem) => {
    this.setState({ department: selectedItem.id, departmentDropdownOpen: false });
  };

  handleCountrySelect = (selectedItem) => {
    this.setState({ countryDropdown: selectedItem.country, countryDropdownOpen: false });
  };

  handlePrivacyConfirm = async () => {
    const { tempPrivacySelection } = this.state;
    if (!tempPrivacySelection) return;
    
    this.setState({ birthdayPrivacy: tempPrivacySelection, showPrivacyModal: false, tempPrivacySelection: null });
    
    const payload = {
      type: 'birthday',
      visible: tempPrivacySelection === 'public',
    };
    try {
      const res = await fetchApi(UpdateBirthdayPrivacy, "POST", payload);
      if (res?.status === "success") {
        toast.success(res?.data?.message || 'Privacy updated');
      } else {
        toast.error(res?.data?.message || 'Failed to update');
      }
    } catch (error) {
      toast.error('Error updating privacy');
    }
  };

  showDatePicker = (value) => {
    this.setState({ showDate: this.state.showDate === value ? '' : value });
  };

  changeDate = (e, stateName) => {
    this.setState({ [stateName]: moment(e._d).format('YYYY-MM-DD'), showDate: '' });
  };

  handleSave = () => {
    const { firstName, lastName, phoneNumber, countryDropdown, birthday, workAnniversary, companyLocation, department, companyName, linkedinProfile } = this.state;
    
    if (!firstName.trim() || !lastName.trim()) {
      toast.error(this.props.t('First Name and Last Name are required'));
      return;
    }

    this.props.onSave({
      fname: firstName,
      lname: lastName,
      phone_number: phoneNumberMaker(phoneNumber),
      country: countryDropdown || '',
      birthday: birthday || '',
      work_anniversary_date: workAnniversary || '',
      company_name: companyName || '',
      linkedin_profile: linkedinProfile || '',
      city_state_id: companyLocation || '',
      department_id: department || ''
    });
  };

  render() {
    const { firstName, lastName, department, phoneNumber, countryDropdown, companyLocation, 
      birthday, birthdayPrivacy, companyName, /*linkedinProfile*/ showDate, 
      locationDropdownOpen, departmentDropdownOpen, countryDropdownOpen,
      locationDetails, departmentDetails, showPrivacyModal, tempPrivacySelection } = this.state;
    const { t } = this.props;

    const yesterday = Datetime.moment().subtract(13, 'years');
    const valid = (currentDate) => currentDate.isBefore(yesterday);

    const countryOptions = countryData.countries;
    
    let selectedLocationTitle = '';
    if (locationDetails && Array.isArray(locationDetails) && companyLocation) {
      const selectedLocation = locationDetails.find((l) => String(l.id) === String(companyLocation));
      selectedLocationTitle = selectedLocation ? (selectedLocation.location || selectedLocation.name) : '';
    }

    let selectedDepartmentTitle = '';
    if (departmentDetails && Array.isArray(departmentDetails) && department) {
      const selectedDepartment = departmentDetails.find((d) => String(d.id) === String(department));
      selectedDepartmentTitle = selectedDepartment ? (selectedDepartment.department || selectedDepartment.name) : '';
    }

    const selectedPrivacyTitle = privacyOptions.find((p) => p.value === birthdayPrivacy)?.label || '';

    return (
      <>
        <FormContainer>
          <FormRow>
            <FormField>
              <InputContainer>
                <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"}>
                  {t("First Name")}<span>*</span>
                </StyledLabel>
                <StyledInputV2
                  placeholder={t("Enter first name")}
                  value={firstName}
                  onChange={(e) => this.handleInputChange('firstName', e.target.value)}
                  bgColor={"white"}
                  border={"0.75px solid #BDBDBD"}
                />
              </InputContainer>
            </FormField>
            <FormField>
              <InputContainer>
                <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"}>
                  {t("Last Name")}<span>*</span>
                </StyledLabel>
                <StyledInputV2
                  placeholder={t("Enter last name")}
                  value={lastName}
                  onChange={(e) => this.handleInputChange('lastName', e.target.value)}
                  bgColor={"white"}
                  border={"0.75px solid #BDBDBD"}
                />
              </InputContainer>
            </FormField>
          </FormRow>

          <FormRow>
            <FormField>
              <InputContainer>
                <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"}>
                  {t("Company")}
                </StyledLabel>
                <StyledInputV2
                  placeholder={t("Enter company name")}
                  value={companyName}
                  onChange={(e) => this.handleInputChange('companyName', e.target.value)}
                  bgColor={"white"}
                  border={"0.75px solid #BDBDBD"}
                />
              </InputContainer>
            </FormField>
            <FormField>
              <CommonDropdown
                labelText={t("Location")}
                placeholder={locationDetails.length > 0 ? t("Select Location") : t("No locations available")}
                title={selectedLocationTitle}
                dropdownOpen={locationDropdownOpen}
                onClick={() => this.setState({ locationDropdownOpen: !locationDropdownOpen })}
                data={locationDetails}
                onSelect={this.handleLocationSelect}
                onSelectParameter={['location', 'id']}
                itemValue={true}
                valueIndex={0}
                dropIcon={true}
                labelMargin={"0px"}
                fontSize={"16px"}
                height={"48px"}
                disabled={locationDetails.length === 0}
                tileContainerStyle={{ width: "100%", padding: "0px" }}
              />
            </FormField>
          </FormRow>

          <FormRow>
            <FormField>
              <CommonDropdown
                labelText={t("Department")}
                placeholder={departmentDetails.length > 0 ? t("Select Department") : t("No departments available")}
                title={selectedDepartmentTitle}
                dropdownOpen={departmentDropdownOpen}
                onClick={() => this.setState({ departmentDropdownOpen: !departmentDropdownOpen })}
                data={departmentDetails}
                onSelect={this.handleDepartmentSelect}
                onSelectParameter={['department', 'id']}
                itemValue={true}
                valueIndex={0}
                dropIcon={true}
                labelMargin={"0px"}
                fontSize={"16px"}
                height={"48px"}
                disabled={departmentDetails.length === 0}
                tileContainerStyle={{ width: "100%", padding: "0px" }}
              />
            </FormField>
            <FormField>
              <CommonDropdown
                labelText={t("Country")}
                placeholder={t("Select Country")}
                title={countryDropdown}
                dropdownOpen={countryDropdownOpen}
                onClick={() => this.setState({ countryDropdownOpen: !countryDropdownOpen })}
                data={countryOptions}
                onSelect={this.handleCountrySelect}
                onSelectParameter={['country']}
                itemValue={true}
                valueIndex={0}
                dropIcon={true}
                labelMargin={"0px"}
                fontSize={"16px"}
                height={"48px"}
                tileContainerStyle={{ width: "100%", padding: "0px" }}
              />
            </FormField>
          </FormRow>

          <FormRow>
            <FormField>
              <InputContainer>
                <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"}>
                  {t("Contact")}
                </StyledLabel>
                <StyledInputV2
                  placeholder="XXX-XXX-XXXX"
                  value={phoneNumber}
                  onChange={(e) => this.handleInputChange('phoneNumber', e.target.value)}
                  bgColor={"white"}
                  border={"0.75px solid #BDBDBD"}
                />
              </InputContainer>
            </FormField>
            <FormField>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"}>
                  {t("Birthday")}
                </StyledLabel>
                <div className='birthday-drop' style={{ width: '120px', cursor: 'pointer' }} onClick={() => this.setState({ showPrivacyModal: true })}>
                  <CommonDropdown
                    placeholder={t("Privacy")}
                    title={selectedPrivacyTitle}
                    dropdownOpen={false}
                    onClick={() => {}}
                    data={[]}
                    onSelect={() => {}}
                    dropIcon={true}
                    height={"32px"}
                    tileContainerStyle={{ width: "100%", padding: "0px" }}
                    top={"8px"}
                  />
                </div>
              </div>
              <DateInputWrapper>
                <Datetime
                  open={showDate === 'birthday'}
                  inputProps={{ placeholder: 'MM/DD/YYYY', readOnly: true }}
                  dateFormat="MM/DD/YYYY"
                  closeOnSelect={true}
                  timeFormat={false}
                  value={birthday ? moment(birthday).format('MM/DD/YYYY') : ''}
                  isValidDate={valid}
                  viewDate={birthday || yesterday}
                  onChange={(e) => this.changeDate(e, 'birthday')}
                  viewMode="years"
                />
                <CalendarIcon onClick={() => this.showDatePicker('birthday')}>
                  {calendarNewIcon()}
                </CalendarIcon>
              </DateInputWrapper>
            </FormField>
          </FormRow>

          {/* <FormRow>
            <FormField>
              <InputContainer>
                <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"}>
                  {t("LinkedIn Profile")}
                </StyledLabel>
                <StyledInputV2
                  placeholder={t("Enter LinkedIn profile URL")}
                  value={linkedinProfile}
                  onChange={(e) => this.handleInputChange('linkedinProfile', e.target.value)}
                  bgColor={"white"}
                  border={"0.75px solid #BDBDBD"}
                />
              </InputContainer>
            </FormField>
            <FormField></FormField>
          </FormRow> */}
        </FormContainer>

        <StyledModalV2 show={showPrivacyModal} onHide={() => this.setState({ showPrivacyModal: false, tempPrivacySelection: null })}>
          <Modal.Header>
            <button 
              type="button" 
              className="close" 
              onClick={() => this.setState({ showPrivacyModal: false, tempPrivacySelection: null })}
              style={{ 
                position: 'absolute', 
                right: '16px', 
                top: '20px', 
                background: 'none', 
                border: 'none', 
                cursor: 'pointer',
                padding: 0,
                zIndex: 1
              }}
            >
              {AdminCloseIcon('#DA6C74')}
            </button>
            <div style={{ width: '100%', textAlign: 'left' }}>
              <p>Control Your Birthday Privacy</p>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div style={{ marginBottom: '16px', color: '#184A61', fontSize: '16px', lineHeight: '24px', fontFamily: 'lato' }}>
              Would you like to share your birthday or keep it private?
            </div>
            <div style={{ marginBottom: '20px', color: '#DA6C74', fontSize: '16px', lineHeight: '20px', fontFamily: 'lato' }}>
              Selecting Private will prevent other users from seeing your birthday and sending wishes on the social feed, but admins will still be able to view your date of birth.
            </div>
            <div style={{ marginBottom: '20px' }}>
              <div 
                style={{ 
                  marginBottom: '20px', 
                  cursor: 'pointer', 
                  borderRadius: '4px',
                  display: 'flex',
                  alignItems: 'center'
                }} 
                onClick={() => this.setState({ tempPrivacySelection: 'private' })}
              >
                <div style={{ 
                  width: '20px', 
                  height: '20px', 
                  borderRadius: '50%', 
                  border: tempPrivacySelection === 'private' ? '1px solid #DA6C74' : '1px solid #BDBDBD',
                  marginRight: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  {tempPrivacySelection === 'private' && (
                    <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#DA6C74' }} />
                  )}
                </div>
                <label style={{ cursor: 'pointer', color: '#184A61', fontFamily: 'lato', fontSize: '16px', margin: 0 }}>Keep Private</label>
              </div>
              <div 
                style={{ 
                  cursor: 'pointer', 
                 
                  borderRadius: '4px',
                  display: 'flex',
                  alignItems: 'center'
                }} 
                onClick={() => this.setState({ tempPrivacySelection: 'public' })}
              >
                <div style={{ 
                  width: '20px', 
                  height: '20px', 
                  borderRadius: '50%', 
                  marginRight: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  border: tempPrivacySelection === 'public' ? '1px solid #DA6C74' : '1px solid #BDBDBD',
                }}>
                  {tempPrivacySelection === 'public' && (
                    <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#DA6C74' }} />
                  )}
                </div>
                <label style={{ cursor: 'pointer', color: '#184A61', fontFamily: 'lato', fontSize: '16px', margin: 0 }}>Make Public</label>
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <button 
                onClick={this.handlePrivacyConfirm}
                disabled={!tempPrivacySelection}
                style={{
                  width: '200px',
                  height: '40px',
                  background: tempPrivacySelection ? '#DA6C74' : '#989898',
                  borderRadius: '4px',
                  border: 'none',
                  color: '#FEFEFE',
                  fontSize: '14px',
                  fontFamily: 'lato',
                  cursor: tempPrivacySelection ? 'pointer' : 'not-allowed'
                }}
              >
                Confirm
              </button>
            </div>
          </Modal.Body>
        </StyledModalV2>
      </>
    );
  }
}

ProfileEditForm.propTypes = {
  user: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onRef: PropTypes.func,
  t: PropTypes.func.isRequired
};

export default withTranslation()(ProfileEditForm);